import { css } from 'emotion';

import { colors } from '../styles';

export const list = css`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  padding: 20px;

  background-color: ${colors.gray.lightest};
  border-radius: 5px;
`;

export const item = css`
  display: inline-flex;
  align-items: center;

  width: calc((100% - 20px) / 3);
  height: 38px;

  padding: 0 10px;
  margin-left: 10px;

  box-sizing: border-box;

  background: ${colors.white};
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;

  &:nth-child(n + 4) {
    margin-top: 10px;
  }
  &:nth-child(3n + 1) {
    margin-left: 0;
  }
`;

export const checkbox = css`
  width: 100%;

  & span:nth-child(2) {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
